module.exports = __webpack_public_path__ + "img/logo-footer.936a64d4.svg";